import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiArrowRight } = FiIcons;

export default function Hero() {
  return (
    <div className="relative min-h-[90vh] lg:h-screen flex items-center justify-center bg-zinc-900 overflow-hidden">
      <div className="absolute inset-0 z-0">
        <img 
          src="https://images.unsplash.com/photo-1556910103-1c02745a872e?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80" 
          alt="Professional Kitchen Prep Station" 
          className="w-full h-full object-cover opacity-50 scale-105 animate-slow-zoom"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-zinc-900 via-zinc-900/60 to-zinc-900/20" />
      </div>

      <div className="relative z-10 text-center px-6 max-w-5xl mx-auto pt-20">
        <motion.div
          initial={{ opacity: 0, scale: 0.9 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8 }}
          className="inline-flex items-center gap-2 bg-red-600/10 border border-red-500/20 px-4 py-2 rounded-full mb-8"
        >
          <span className="w-2 h-2 rounded-full bg-red-500 animate-pulse" />
          <span className="text-red-400 font-bold uppercase tracking-widest text-[10px]">Professional Grade Equipment</span>
        </motion.div>
        
        <motion.h1 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-5xl md:text-7xl lg:text-8xl font-black text-white mb-8 tracking-tighter leading-[0.9]"
        >
          MASTER YOUR <br/> <span className="text-transparent bg-clip-text bg-gradient-to-r from-zinc-100 to-zinc-400">PREP STATION.</span>
        </motion.h1>
        
        <motion.p 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="text-lg md:text-2xl text-zinc-300 mb-12 max-w-2xl mx-auto font-medium leading-relaxed"
        >
          Engineered for precision, forged for durability. Equipping the world's most demanding kitchens since 1994.
        </motion.p>
        
        <motion.div 
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          className="flex flex-col sm:flex-row gap-4 justify-center"
        >
          <button className="btn-primary group text-lg">
            Shop Collection
            <SafeIcon icon={FiArrowRight} className="group-hover:translate-x-1 transition-transform" />
          </button>
          <button className="btn-secondary text-lg">
            Explore Bundles
          </button>
        </motion.div>
      </div>

      {/* Floating Badge */}
      <motion.div 
        initial={{ opacity: 0, rotate: -10 }}
        animate={{ opacity: 1, rotate: 0 }}
        transition={{ duration: 1, delay: 1 }}
        className="absolute bottom-12 right-12 hidden lg:flex flex-col items-center gap-2 border border-white/20 p-6 backdrop-blur-md rounded-sm"
      >
        <span className="text-zinc-400 uppercase text-[10px] tracking-[0.2em] font-bold">Chef Approved</span>
        <div className="flex text-red-500">
          {[...Array(5)].map((_, i) => <SafeIcon key={i} icon="FiStar" className="fill-current text-sm" />)}
        </div>
      </motion.div>
    </div>
  );
}